import { models } from 'powerbi-client';

export interface ScreenInfo {
  width: number;
  height: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  orientation: 'portrait' | 'landscape';
}

export class ScreenDetectionUtil {
  static getScreenInfo(): ScreenInfo {
    const width = window.innerWidth;
    const height = window.innerHeight;
    
    return {
      width,
      height,
      isMobile: width <= 768,
      isTablet: width > 768 && width <= 1024,
      isDesktop: width > 1024,
      orientation: width > height ? 'landscape' : 'portrait'
    };
  }


  static getLayoutType(screenInfo?: ScreenInfo): models.LayoutType {
    const currentScreenInfo = screenInfo || this.getScreenInfo();

    if (currentScreenInfo.isMobile) {
      return currentScreenInfo.orientation === 'portrait'
        ? models.LayoutType.MobilePortrait
        : models.LayoutType.MobileLandscape;
    }
    
    return models.LayoutType.Master;
  }

  static addScreenListener(
    callback: (screenInfo: ScreenInfo) => void
  ): () => void {
    const handleResize = () => {
      const screenInfo = this.getScreenInfo();
      callback(screenInfo);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }
}

import { useState, useEffect } from 'react';

export const useScreenDetection = () => {
  const [screenInfo, setScreenInfo] = useState<ScreenInfo>(
    ScreenDetectionUtil.getScreenInfo()
  );

  useEffect(() => {
    const cleanup = ScreenDetectionUtil.addScreenListener(setScreenInfo);

    return cleanup;
  }, []);

  const layoutType = ScreenDetectionUtil.getLayoutType(screenInfo);

  return {
    screenInfo,
    layoutType
  };
};